import React, { useEffect } from 'react';
import { IconClear } from '@bynder/icons';
import { initMessageBox } from '../../legacy/messagebox';

export default function MessageBox() {
	useEffect(() => {
		initMessageBox();
	}, []);

	return (
		<>
			<div className="loader hidden" style={{ display: 'none' }}>
				<div style={{ width: '40%' }} />
				<span>
					<span />
				</span>
			</div>
			<div className="notification">
				<h1>
					<i className="icon-tasks-white" />
				</h1>
				<span className="extended" />

				<a href="#" className="cancel">
					<IconClear />
				</a>
			</div>
		</>
	);
}
